var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"w-240 border border-gray-400 outline-none p-1 bg-transparent",attrs:{"type":"date"},domProps:{"value":_vm.display},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }